import React from 'react';
import RegisterForm from './Forms/RegisterForm';
import '../css/Forms.scss';

function Register() {
    return <RegisterForm />;
}

export default Register;
